import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Pfeil, der bei Hover des umgebenden `group`-Elements nach rechts einblendet.
 * Erwartet einen Flex-Parent mit `gap-2` – der negative Margin gleicht das Gap
 * im eingeklappten Zustand aus, damit das Label zentriert bleibt.
 */
export default function HoverArrow({
  size = 15,
  className,
}: {
  size?: number;
  className?: string;
}) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex w-0 -ml-2 opacity-0 overflow-hidden transition-all duration-300 ease-out",
        "group-hover:w-4 group-hover:ml-0 group-hover:opacity-100",
        className
      )}
    >
      <ArrowRight size={size} className="shrink-0" />
    </span>
  );
}
